var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagForGhana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.34229C7.34605 1.34229 3.40262 4.29097 1.94604 8.44755H22.0539C20.5974 4.29097 16.6539 1.34229 12 1.34229Z",
    fill: "#C94747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.6582C16.6539 22.6582 20.5974 19.7096 22.0539 15.553H1.94604C3.40262 19.7096 7.34605 22.6582 12 22.6582Z",
    fill: "#699635"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94611 8.44751C1.55532 9.54883 1.34216 10.7567 1.34216 12.0001C1.34216 13.2436 1.55532 14.4515 1.94611 15.5528H22.054C22.4448 14.4515 22.658 13.2436 22.658 12.0001C22.658 10.7567 22.4448 9.54883 22.054 8.44751H1.94611Z",
    fill: "#FFCE31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.883L14.2027 15.5528L13.35 12.8528L15.5526 11.112H12.8527L12 8.44751L11.1829 11.112H8.44739L10.65 12.8528L9.79739 15.5528L12 13.883Z",
    fill: "#3E4347"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagForGhana);
export default __webpack_public_path__ + "static/media/flag-for-ghana.dce44c142609f7e8806f92748ca8a850.svg";
export { ForwardRef as ReactComponent };